import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import markup from "ulysses/features/quote_editor.html";
import "ulysses/widgets";

ko.bindingHandlers.quoteeditor = {
    init: function(elt, va, allbindings, komodel, context) {
        $(elt).html(markup);
        var items = ko.unwrap(va());
        items.forEach(function(item, idx) {
            item.total_price = {
                foreign: ko.pureComputed(function() { return item.unit_no() * item.unit_price.foreign() - item.discount_value.foreign(); })
            };
        });
        
        var model = {
            items: va(),
            add_item: function() {
                var item = {
                    product: { id:ko.observable(), unique_id:ko.observable(), name: ko.observable() },
                    description: ko.observable(),
                    product_id: ko.observable(),
                    unit_no: ko.observable(1.0),
                    unit_price: { foreign:ko.observable(0), native:ko.observable(0), currency_id:ko.observable(), currency:{name:ko.observable(), rate:ko.observable(1)}},
                    discount_value: {
                        foreign:ko.observable(0)
                    },
                    is_optional: ko.observable(false),
                    id: ko.observable(null),
                    item_sequence: ko.observable(0)
                };
                item.total_price = {
                    foreign: ko.pureComputed(function() { return item.unit_no() * item.unit_price.foreign() - item.discount_value.foreign(); })
                };
                item.item_sequence(ko.unwrap(model.items).length + 1);
                model.items.push(item);
            },
            move_up: function(item) {
                var items = ko.unwrap(model.items);
                var idx = items.indexOf(item);
                if (idx > 0) {
                    var pitem = items[idx-1];
                    pitem.item_sequence(idx);
                    item.item_sequence(idx-1);
                    model.items.splice(idx-1, 2, item, pitem);
                }
            },
            move_down: function(item) {
                var items = ko.unwrap(model.items);
                var idx = items.indexOf(item);
                if (idx < items.length - 1) {
                    var pitem = items[idx+1];
                    pitem.item_sequence(idx);
                    item.item_sequence(idx+1);
                    model.items.splice(idx, 2, pitem, item);
                }
            },
            delete_item: function(item) {
                var items = ko.unwrap(model.items);
                var idx = items.indexOf(item);
                model.items.splice(idx,1);
            },
            toggle_optional: function(item){
                console.log("togge:", arguments);
                item.is_optional(!item.is_optional());
            }
        };
        
        model.estimated_total= ko.pureComputed(function() {
            var total = 0;
            ko.unwrap(model.items).forEach(function(item, idx) {
                console.log("item:", item, idx);
                total += (ko.unwrap(item.total_price.foreign)||0);
            });
            return total;
        });
        var new_model = context.createChildContext(model);
        ko.applyBindingsToDescendants(new_model, elt);
        return {"controlsDescendantBindings":true};
    },
    update: function(elt,va,allbindings) {
    }
};
